module.exports = __webpack_public_path__ + "img/kommune-540.58afd580.svg";